import bongoHome from '../../../images/bongo-library/home.png';
import bongoLogin from '../../../images/bongo-library/login-page.png'
import bongoAdmin from '../../../images/bongo-library/admin-pannel.png';
import spectaHome from '../../../images/specta/home.png'
import spectaService from '../../../images/specta/services.png'
import spectaFeature from '../../../images/specta/features.png'
import spectaContact from '../../../images/specta/contact.png'
import hotCHome from '../../../images/hot-chilies/home.png'
import hotCFoodDetails from '../../../images/hot-chilies/food-details.png'
import hotCOrder from '../../../images/hot-chilies/order.png'
import cInfoDetails  from '../../../images/country-info/details.png'
import cInfoHome from '../../../images/country-info/home.png';
import car from '../../../images/car.PNG';
import cycle from '../../../images/cycle.PNG';
import rider from '../../../images/rider.PNG';
import league from '../../../images/league.PNG';

const demoData =[
    {id:1, name: 'Car Care', image: 'https://i.ibb.co/7YgKCsP/car.png', live: 'https://car-care-87fdd.web.app/', github: 'https://github.com/nabilwoalidrafiu/car-care-client'},
    {id:2, name: 'Cycle Hut', image: 'https://i.ibb.co/Q8y62hg/cycle.png', live: 'https://cycle-hut.web.app/', github: 'https://github.com/nabilwoalidrafiu/cycle-hut-client'},
    {id:3, name: 'Rapid Riders', image: 'https://i.ibb.co/k0yqPpw/rider.png', live: 'http://rapid-riders.web.app/', github: 'https://github.com/nabilwoalidrafiu/rapid-riders'},
    {id:4, name: 'Premier League', image: 'https://i.ibb.co/cTj9Bwv/league.png', live: 'https://my-premier-league.netlify.app/', github: 'https://github.com/nabilwoalidrafiu/my-premier-league'},
    {id:5, name: 'Penguin Fashion', image: 'https://i.ibb.co/Lk58C5f/fashion.png', live: 'https://nabilwoalidrafiu.github.io/penguin-fashion/', github: 'https://github.com/nabilwoalidrafiu/penguin-fashion'}
]

 const ProjectData = [
   
    {
        id: 1,
        description: "",
        tools:[ "React","CSS3","Firebase","MongoDB","Node Js","Express Js", "Heroku", "Stripe" ],
        images: [
            // bongoHome,
            // bongoLogin,
            // bongoAdmin
        car
        ],
        title: "Car Care",
        liveLink: "https://car-care-87fdd.web.app/",
    repoLink:"https://github.com/nabilwoalidrafiu/car-care-client"
    } ,
      
    {
        id: 2,
        description: " ",
       tools:[ "React","CSS3","Firebase","MongoDB","Node Js","Express Js",],
       images: [
    //    spectaHome,spectaFeature,spectaService,spectaContact
    cycle
       ],
       title: "Cycle Hut",
       liveLink: "https://cycle-hut.web.app/",
   repoLink:"https://github.com/nabilwoalidrafiu/cycle-hut-client"
   } ,
    {
        id: 3,
        description: "",
        tools:[ "React","CSS3","Firebase","MongoDB","Node Js","Express Js"],
        images: [
            // hotCHome,
            // hotCFoodDetails,
            // hotCOrder
        rider
        ],
    title: 'Rapid Riders',
     liveLink: 'http://rapid-riders.web.app/',
      repoLink: 'https://github.com/nabilwoalidrafiu/rapid-riders'
    } ,
    {
        id: 4,
        description: "",
        tools:[ "React","CSS3","Rest API" ],
        images: [
            // cInfoHome,
            // cInfoDetails
            league
        ],
    title: 'Premier League', 
    liveLink: 'https://my-premier-league.netlify.app/', 
    repoLink: 'https://github.com/nabilwoalidrafiu/my-premier-league'
    } ,
]

export default ProjectData;